export default __webpack_public_path__ + "static/aws-ccf4849ca972e3aa4ffde6920c7b277a.png";